// extracted by mini-css-extract-plugin
export default {"text":"a2WsA","external":"b2WsA","linkColor":"c2WsA","quote":"d2WsA","listMarkdown":"e2WsA","img":"f2WsA","center":"g2WsA"};